import Panel from '@admin/components/panel'
import TeamToken from '@admin/tokens/team'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 'Interventions',
  collection: {
    endpoint: '/api/admin/truevail/admin/deliverability/interventions',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Team)', key: 'team', primary: true, format: (intervention) => (
        <TeamToken { ...intervention.team } />
      ) },
      { label: 't(Type)', key: 'type' },
      { label: 't(Reason)', key: 'reason' },
      { label: 't(Timestamp)', key: 'created_at', collapsing: true, format: 'datetime' }
    ],
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      icon: 'building-o',
      title: 't(No Interventions)',
      text: 't(There are not currently any deliverability interventions)'
    },
    entity: 'intervention'
  }
})

export default Panel(null, mapPropsToPanel)
